import React from 'react'
import { connect } from 'react-redux'
import torrents from '../http/proxy'
import psyco from '../http/psyco'
import { filesize } from 'filesize'

class IndexPage extends React.Component {
  constructor (props){
    super(props)

    this.state = {
      userInfo: {
        // username: 'Loading...',
        // id: '?',
        keys: '?',
        // downloaded: '?',
        // uploaded: '?',
        // ratio: '?',
      },
      serverInfo: {
        space: 'Loading...',
      },
    }
  }

  componentDidMount() {
    // user infos
    if (this.props.userData.data === undefined) {
      this.fetchUserInfos()
    } else {
      this.showUserInfos(this.props.userData.data)
    }
    // psyco server infos
    if (this.props.serverData.data === undefined) {
      this.fetchServerInfos()
    } else {
      this.showServerInfos(this.props.serverData.data)
    }
  }

  fetchUserInfos() {
    torrents.get_user_info((results) => {
      this.props.dispatch({
        'type': 'INIT',
        'data': results.data,
      })
      if (results.data !== undefined) {
        this.showUserInfos(results.data)
      } else {
        this.setState({
          userInfo: {
            // username: 'Error retrieving infos.',
            // id: '?',
            keys: '?',
            // downloaded: '?',
            // uploaded: '?',
            // ratio: '?',
          },
        })
      }
    })
  }

  fetchServerInfos() {
    psyco.getSpace((results) => {
      this.props.dispatch({
        'type': 'INIT',
        'data': results.data,
      })
      this.showServerInfos(results.data)
    })
  }

  showUserInfos(infos) {
    this.setState({
      userInfo: {
        // username: infos.username,
        // id: infos.id,
        keys: infos.keys,
        // downloaded: filesize(infos.downloaded),
        // uploaded: filesize(infos.uploaded),
        // ratio: parseFloat(Number(infos.uploaded) / Number(infos.downloaded)).toFixed(2),
      },
    })
  }

  showServerInfos(infos) {
    this.setState({
      serverInfo: {
        space: filesize(infos.space),
      },
    })
  }

  renderKeys(keys) {
    if (typeof keys === 'object') {
      const rows = keys.map((key) => {
        let list = []
        for (let name in key) {
          if (key[name] !== undefined) {
            list.push(
              <li>
                { name.concat(': ').concat(key[name]) }
              </li>
            )
          }
        }
        return list
      })
      return rows
    }
    return null
  }

  render() {
    const username = localStorage.getItem('username')
    return (
      <div className="container">
        <div className="jumbotron col-xs-6">
          <p>Bienvenue <strong>{username}</strong> !</p>
          <ul className="lead">
            * Keys *
            { this.renderKeys(this.state.userInfo.keys) }
          </ul>
        </div>
        <div className="jumbotron col-xs-5 pull-right">
          <p>Statut <strong>psyco.fr</strong></p>
          <ul className="lead">
            <li>Espace restant: {this.state.serverInfo.space}</li>
          </ul>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  userData: state.user,
  serverData: state.server
})

export default connect(mapStateToProps)(IndexPage)
